import { IhmLoginTokenProvider } from '@api/utils/IhmLoginTokenProvider'
import { IIBTokenProvider } from '@api/utils/IIBTokenProvider'
import { EnvironmentDetail, DeviceDetails } from '@amzn/ihm-associate-tools-js-lib'
import { generateDeferredPromise } from '@utils/DeferredPomiseUtil'
import { AssociateToolsLoginAuditTrailService } from '@services/AssociateToolsLoginAuditTrailService'
import { TokenUtils } from '@utils/TokenUtils'
import * as DeviceRegistryService from '@services/DeviceRegistryService'
import { cordovaExec } from '@services/CandyCaneService'
import { EnvironmentPluginConstants } from '@utils/Constants/EnvironmentPluginConstants'

export class LogoutUtils {
    /**
     * Called from Logout component. Logout component waits on the returned promise then clears ihmLogin token.
     * Collects appInstallId, pushToken, userAlias before making updateDevice call.
     * @returns {Promise}: Resolves when:
     *                     1. _updateDevice call is successful.
     *                     2. _updateDevice call is failed.
     *                     2. _updateDevice call is not required.
     * Note: Promise need to be resolved in all cases.
     */
    public static async onLogoutDeregisterDevice () {
        await DeviceRegistryService.onLogoutDeregisterDevice()
    }

    public static async clearAllCookiesFromWebView () {
        if (EnvironmentDetail.isAndroid()) {
            await cordovaExec(EnvironmentPluginConstants.ENVIRONMENT_PLUGIN_NAME, EnvironmentPluginConstants.ACTION_CLEAR_COOKIES,[])
        }
    }

    public static async emitLogoutAssociateAuditTrailEventIfRequired (primaryStore: string) {
        const devicePlatform = EnvironmentDetail.getDevicePlatform()
        console.debug('checking device platform before publishing logout signal to labor tracking service , platform= ' + devicePlatform)
        if (!EnvironmentDetail.isAndroid()) {
            console.debug('This is not an Android device. Not emitting logout audit event')
            return Promise.resolve()
        }
        const deferred = generateDeferredPromise()
        try {
            // check token validity for IIB
            if (EnvironmentDetail.isIIBAuthN()) {
                if (!await IhmLoginTokenProvider.isTokenSet()) {
                    console.warn('No access token found. Not emitting logout audit event')
                    return Promise.resolve()
                }
                const accessToken = await IhmLoginTokenProvider.getAccessToken()
                if (TokenUtils.isTokenExpired(accessToken)) {
                    console.warn('Access Token is expired. Not emitting logout audit event')
                    return Promise.resolve()
                }
            }

            const deviceDetails: {deviceSerialNumber?: string} = await DeviceDetails.getDeviceDetails()
            const dsn = deviceDetails.deviceSerialNumber
            console.info('ATBase: Publishing AssociateToolsLogout: dsn=' + dsn)
            AssociateToolsLoginAuditTrailService.emitAssociateToolsLogoutEvent(primaryStore, devicePlatform, dsn)
                .catch((error) => {
                    console.error('ATBase: LogoutController: associate tools logout signal emit encountered an error ', error)
                })
                .finally(() => deferred.resolve({}))
        } catch (exception) {
            console.error('ATBase: AssociateToolsLogout: encountered an exception', exception)
            return Promise.reject(exception)
        }
        return deferred.promise
    }

}
